<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <!-- <span>Vuetify</span> -->
        <span class="font-weight-light">Individualized Precision Prevention</span>
        <v-icon v-if='currentPatientID!=null' style='margin-left: 250px;'>person</v-icon>
        <span v-if='currentPatientID!=null'>{{currentPatientID}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        flat
        light
        icon
        color="#666"
        @click='dialog=true'
      >
        <span class="mdi mdi-settings mdi-24px"></span>
      </v-btn>
      <v-btn
        flat
        light
        icon
        color="#666"
      >
        <a href='https://kgrid-objects.github.io/ipp-collection' target='_blank'><span class="mdi mdi-information-outline mdi-24px"></span></a>
      </v-btn>
    </v-toolbar>
    <v-content>
      <router-view/>
    </v-content>
    <statuspanel v-on:hidelog='backhome'/>
    <patientselector v-on:hideselector='backhome'/>
    <v-bottom-nav
       :active.sync="bottomNav"
       :value="true"
       absolute
       color="transparent">
      <v-btn
       color="teal"
       flat
       value="patient"
      >
        <span>Select Patient</span>
        <v-icon>people</v-icon>
      </v-btn>
      <v-btn
        color="teal"
        flat
        value="home"
        @click.stop="$router.push({'name':'home'})"
        >
        <span>Home</span>
        <v-icon>home</v-icon>
      </v-btn>
     <v-btn
       color="teal"
       flat
       value="log"
     >
       <span>View App Log</span>
       <v-icon>event_note</v-icon>
     </v-btn>
    </v-bottom-nav>
    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Config Activator</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap my-2 >
					<v-flex xs3>
						<span class='title'>Activator Site URL</span>
					</v-flex>
					<v-flex xs7>
						<v-text-field
							label="Activator Site URL"
							box
							solo
							v-model='activatorurl'
						></v-text-field>
					</v-flex>
				<v-flex xs2>
					<div class='col-md-2'>
						<v-btn
						 color="#0075bc"
						 outline
						 @click='addactivatorentry'
						 v-if='activatorurlindex==-1'
						 >
						 <span>Save URL</span>
					 </v-btn>
					 <v-btn
						color="#0075bc"
						outline
						@click='setdefaultactivator'
						v-if='!isDefaultActivator'
						>
						<span>Set as Default</span>
					</v-btn>
					</div>
				</v-flex>
			</v-layout>

			<v-layout row wrap my-5>
				<v-flex xs3>
						<span class='title'>Available Activator Sites</span>
				</v-flex>
				<v-flex xs9>
					<v-radio-group v-model='activatorurlselect' :mandatory="false" >
						<v-layout row wrap v-for="(entry,index) in activatorurls" :key='entry' my-1 py-2 align-center fill-height>
							<v-flex xs10>
								<v-radio :label="entry" :value="entry"></v-radio>
							</v-flex>
							<v-flex xs2>
								<v-btn
								 fab
								 small
								 color="#0075bc"
								 outline
								 @click='deleteactentry(index)'
								 :disabled='(index==defaultactivatorindex)||(index==activatorurlindex)'
								>
								 <v-icon>clear</v-icon>
								</v-btn>
							</v-flex>
							<v-divider></v-divider>
						</v-layout>
					</v-radio-group>
				</v-flex>
				</v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
          <!-- <v-btn color="blue darken-1" flat @click="dialog = false">Save</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import statuspanel from './components/statuspanel'
import patientselector from './components/patientselector'
export default {
  name: 'App',
  components: {
    statuspanel,
    patientselector
  },
  data () {
    return {
      bottomNav: 'home',
      dialog: false,
      activatorurls:[],
      activatorurl:'',
      activatorurlselect:'',
    }
  },
  created: function(){
    var self = this
    this.$http.all([
      // this.$http.get('./json/initdata.json'),
      this.$http.get('./json/studydata.json'),
      // this.$http.get('https://demo.kgrid.org/schemas/ippPatientFeaturesSample.json'),
      this.$http.get('./json/ippPatientFeaturesSample.json'),
      this.$http.get('./json/groupDisplaySchema.json')
    ]).then(this.$http.spread(function (patients, panel,groupdisplay) {
      console.log(panel)
      self.$store.commit('setPatientData',patients.data.patientData)
      self.$store.commit('setFeatureSamplePanel',panel.data)
      self.$store.commit('setGroupDisplaySchema',groupdisplay.data.schema)
    })).catch(error=>{
      console.log(error)
    })
		this.activatorurls=this.$store.getters.getactivatorurls
  },
  mounted:function(){
    this.activatorurl=this.activatorurls[this.defaultactivatorindex]
    this.activatorurlselect=this.activatorurl
  },
  watch: {
    bottomNav: function(){
      console.log(this.bottomNav)
      switch(this.bottomNav){
        case 'log':
          this.togglelog()
          break;
        case 'patient':
          this.openselector()
          break;
        default:
          break;
      }

    },
    activatorurlselect () {
			this.selectactivatorsite()
		}
  },
  methods: {
    selectactivatorsite:function(){
      this.activatorurl=this.activatorurlselect
      this.$store.commit("setcurrentactivatorurl",this.activatorurl)
    },
    togglelog:function(){
      this.$bus.$emit('togglelog', true)
    },
    openselector: function(){
      this.$bus.$emit('openselector',true)
    },
    backhome:function(){
      this.bottomNav = 'home'
    },
    addactivatorentry:function(){
      this.activatorurls.push(this.activatorurl)
      this.activatorurlselect=this.activatorurl
      this.$store.commit('setactivatorurls', this.activatorurls)
    },
    deleteactentry:function(i){
      this.activatorurls.splice(i,1)
      this.$store.commit('setactivatorurls', this.activatorurls)
    },
    setdefaultactivator:function(){
      console.log(this.activatorurlindex)
      this.$store.commit("setdefaultactivatorurlindex", this.activatorurlindex)
    }
  },
  computed:{
    currentPatientID: function(){
      return this.$store.getters.getCurrentPatientID
    },
    defaultactivatorindex: function(){
      return this.$store.getters.getdefaultactivatorurlindex
    },
    activatorurlindex: function(){
      return this.activatorurls.indexOf(this.activatorurl)
    },
    isDefaultActivator: function(){
      if(this.activatorurlindex!=-1){
        return (this.defaultactivatorindex==this.activatorurlindex)
      }else {
        return true
      }
    },
  }
}
</script>
<style>

::-webkit-scrollbar {
    width: 10px;
}

::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
    border-radius: 0px;
}

::-webkit-scrollbar-thumb {
    border-radius: 0px;
/*     -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);  */
}
::-webkit-scrollbar-track {
      background-color: #fff;
} /* the new scrollbar will have a flat appearance with the set background color */

::-webkit-scrollbar-thumb {
      background-color: #eeeeee;
} /* this will style the thumb, ignoring the track */

::-webkit-scrollbar-button {
    display:none;
    background-color: #e5e5e5;
} /* optionally, you can style the top and the bottom buttons (left and right for horizontal bars) */

::-webkit-scrollbar-corner {
      background-color: #fff;
} /* if both the vertical and the horizontal bars appear, then perhaps the right bottom corner also needs to be styled */
</style>
